export default "__VITE_ASSET__Dka7uTKl__"